import { graphql } from 'gatsby';

export { default } from './Blog';

export const blogListQuery = graphql`
  query BlogListQuery($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { templateKey: { eq: "BlogPost" } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          excerpt(pruneLength: 400)
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
            excerpt
            featuredimage {
              childImageSharp {
                desktop: fixed(width: 330, height: 192) {
                  ...GatsbyImageSharpFixed_noBase64
                }

                mobile: fluid(maxWidth: 870, maxHeight: 650) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`;
